import{jsx as t}from"react/jsx-runtime";import a from"styled-components";import{withVDSManager as e}from"@vds-core/utilities";import i from"./PaginationControls.js";import n from"./PaginationNumbers.js";const c=a.nav.withConfig({displayName:"StyledNav",componentId:"VDS__sc-148xq6w-0"})`
  width: ${"288px"};
  &:hover {
    outline: none;
  }
`,o=a.ul.withConfig({displayName:"StyledList",componentId:"VDS__sc-148xq6w-1"})`
  margin: 0;
  padding: 0;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  list-style-type: none;
`,r=function(a){const{"data-analyticstrack":e,"data-track":r,"data-track-ignore":s,"data-clickstream":l,"data-sitecat-cta":d,"data-sitecat-datatrack":g,"data-sitecat-position":m,"data-sitecat-level":p,total:f}=a,u=Object.assign({},a);return t(c,{id:a.id,tabIndex:-1,"aria-label":"Pagination",onClick:function(t){"click"===t.type&&t.currentTarget.blur()},"data-analyticstrack":e,"data-track":r,"data-track-ignore":s,"data-clickstream":l,children:t(o,{children:t(i,Object.assign({total:f,dataTrack:g,position:m,level:p,cta:d},u,{children:t(n,Object.assign({selectPage:a.selectPage,selectedPage:a.selectedPage,total:f},u))}))})})};r.defaultProps={total:20,selectedPage:10,surface:"light"};var s=e(r);export{s as default};
